import React, {useState} from "react";
import Pict1 from "./img/1.jpg";
import MediaQuery from "react-responsive";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "../Programlinear/1/Part1.css"

const Part1 = () => {
	const [ukuranH,setUkuranH]=useState(19)
	const [ukuranP,setUkuranP]=useState(15)
	const sizeplus =()=>{
		setUkuranH(ukuranH+1)
		setUkuranP(ukuranP+1)
	}
	const sizemin =()=>{
		setUkuranH(ukuranH-1)
		setUkuranP(ukuranP-1)
	}
	return (
		<div className="container">
		<div className="d-flex justify-content-end">
		<button className="btnplus" onClick={sizeplus}><h6>A<sub>+</sub></h6></button>
		<button className="btnplus" onClick={sizemin}><h6>A<sub>-</sub></h6></button>
		</div>
			<div className="row">
				<div className=" col-sm-3 col-md-12 col-lg-12 ">
					<div
						style={{
							fontSize: "19px",
							width: "50%",
							color: "green",
							borderRadius: "25px",
						}}
					>
						<strong style={{fontSize:`${ukuranH}px`}}>Tujuan Pembelajaran</strong>
					</div>
				</div>
				<div className="col-sm mt-2">
					<div
						style={{
							width: "100%",
							borderStyle: "inset",
							borderRadius: "25px",
							borderColor: "#70db70",
							paddingTop: "10px",
							textAlign: "justify",
							boxShadow: "5px 5px #888888",
							backgroundColor :"#f0f5f5"
						}}
					>
						<div className="col">
							<div
								style={{
									width: "100%",
									marginTop: "1rem",
									textAlign: "justify",
								}}
							>
								<div
									style={{
										textAlign: "justify",
										lineHeight: "20px",
										paddingRight: "10px",
									}}
								>
									<ol style={{fontSize:`${ukuranP}px`}}>
										<li>
											Siswa dapat menentukan nilai optimum dari suatu masalah
											program linear dua variabel.
										</li>
									</ol>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<p className="mt-3" style={{
									textIndent: "2rem",
									width: "100%",
									textAlign: "justify",
									lineHeight: "35px",
									fontSize : `${ukuranP}px`
								}}>Nah setelah mempelejari sistem pertidaksamaan linear dua variabel dan juga mencari model matematika, kali ini kalian masuk ke bagian akhir dari materi ini, yaitu mencari nilai optimum. Ada dua cara yaitu metode uji titik pojok dan metode garis selidik. Sebelum berpindah halaman, Ayo simak pengantar di bawah ini, dan jangan lupa baca secara keseluruhan ya! &#128513; &#128077;</p>
			<div className="card mt-2 border-success shadow  bg-body rounded mt-2">
				<div
					style={{ backgroundColor: "#2d8659" }}
					className="card-header text-white text-center"
				>
					<h6 style={{fontSize:`${ukuranH}px`}}>Pengantar</h6>
				</div>
				<div className="card-body" style={{ backgroundColor: "#f0f5f5" }}>
					<div className="row">
						<div className="col-sm-12 ">
							<div
								style={{
									textIndent: "2rem",
									width: "100%",
									textAlign: "justify",
									lineHeight: "35px",
								}}
							>
								<p style={{fontSize:`${ukuranP}px`}}> 
								Pak Amin, seorang penjual sepeda. Beliau ingin membeli sepeda untuk peserdiaan di toko, maksimal 25 unit. Untuk itu, beliau telah menyiapkan uang Rp46.000.000,00. Jenis sepeda yang hendak dibeli adalah jenis sepeda gunung dengan harga Rp1.400.000,00 dan sepeda lipat dengan harga Rp2.000.000,00 perunitnya. Rencananya Pak Amin akan meambil keuntungan Rp100.000,00 dari setiap penjualan sepeda gunung dan Rp150.000,00 dari sepeda lipat. Nah maka berapakah keuntungan maksimum yang didapat oleh Pak Amin?
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<p
				className="mt-4 mb-2"
				style={{ lineHeight: "35px", textAlign: "justify", textIndent: "2rem", fontSize:`${ukuranP}px` }}
			>
				Masalah yang dihadapi Pak Amin dapat dijawab dengan penyelesaian program
				linear.
				Nah, dalam mencari pendapatan maksimum dari penjualan sepeda inilah yang disebut juga sebagai nilai
				optimum. Nilai optimum ada dua jenis yaitu nilai yang menunjuk pada
				nilai maksimum dan nilai minimum. Mencari nilai optimum dari suatu
				masalah, apakah akan di cari nilai maksimum atau mencari nilai
				minumumnya, maka itu tergantung dari permasalahan yang diberikan. Bentuk
				dari nilai optimum berbentuk fungsi yang disebut dengan fungsi objektif.
				Secara umum fungsi objektif dituliskan{" "}
				<b>
					<i>f(x,y) = ax + by atau z = ax + by</i>
				</b>
				. Dalam hal ini terdapat dua metode yang digunakan dalam nilai optimum
				yaitu metode uji titik pojok dan metode selidik.
			</p>
			<div className="d-flex justify-content-center">
				<MediaQuery minWidth={476} maxWidth={1824}>
					<TransformWrapper defaultScale={1}>
						<TransformComponent>
							<img src={Pict1} alt="Pict1" />
						</TransformComponent>
					</TransformWrapper>
				</MediaQuery>
			</div>
			<MediaQuery maxWidth={475}>
				<TransformWrapper defaultScale={1}>
					<TransformComponent>
						<img
							style={{ height: "200px", width: "200px" }}
							src={Pict1}
							alt="Pict1"
						/>
					</TransformComponent>
				</TransformWrapper>
			</MediaQuery>
			<div className="text-center" style={{fontSize:`${ukuranP}px`}}><i><b>Gambar :</b> dua metode dalam mencari nilai optimum</i></div>
		</div>
	);
};

export default Part1;
